import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import {h} from "preact";

export let SwitcherButtons = ({children}) => <div class="flex w-full bg-harif-800 border-t border-b border-t-harif-900 border-b-harif-900">{children}</div>
export let Button = ({children, selected, onClick}) => {
	if (selected)
		return <div class="w-full cursor-pointer border-l border-b border-harif-950 bg-harif-800 text-center py-2 text-xl underline">{children}</div>
	return <div class="w-full cursor-pointer border-l border-b border-harif-950 bg-harif-900 text-center py-2 text-xl" onClick={onClick}>{children}</div>
}

export let TabContainer = ({children}) => <div class="w-full">{children}</div>

export let MatchesTable = ({children}) => <div class="w-full">{children}</div>

export let MarketsStrip = ({children}) => <div class="flex gap-2 w-full bg-harif-800 botder-t boder-b border-t-harif-700 border-b-harif-850">{children}</div>
export let MarketName = ({children, size}) => {
	return <div data-size={size} class="text-center text-sm h-8 flex items-center justify-center min-w-0 w-10 data-[size='2']:grow-2 data-[size='3']:grow-3">{children}</div>;
}

export let Matches = ({children}) => <div class="">{children}</div>
export let MatchRow = ({children}) => <div class="border-t border-harif-900">{children}</div>

export let MatchInfo = ({children, onClick}) => <div class="" onClick={onClick}>{children}</div>

export let MatchTopInfo = ({children}) => <div class="flex px-1 justify-between w-full text-xs bg-harif-800 border-t border-t-harif-700 ">{children}</div>
export let MatchTournament = ({event, tournament, category, sport}) => <div class="">{sport.name} - {category.name} - {tournament.name}</div>
export let MatchDate = ({children, date}) => <div class="">{new Date(date).toLocaleString()}</div>

export let MainMatchInfo = ({children}) => <div class="flex justify-between w-full bg-harif-800 border-b border-b-harif-950">{children}</div>
export let MatchName = ({event}) => <div class="grow text-left">{event.home} - {event.away}</div>
export let AvailableMarkets = ({children, onClick}) => <div class="py-0.5 px-2 cursor-pointer bg-amber-500 text-black text-xs flex items-center" onClick={onClick}><Trans>More</Trans></div>

export let Markets = ({children}) => <div class="flex gap-2 w-full">{children}</div>
export let Market = ({children, size}) => {
	if (size == 2)
		return <div class="rounded-xl min-w-0 w-10 flex gap-1 justify-stretch items-stretch grow-2 text-sm">{children}</div>
	return <div class="rounded-xl min-w-0 w-10 flex gap-1 justify-stretch items-stretch grow-3 text-sm">{children}</div>
}
